import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldGroup } from '../../../libs/formLib';
import ButtonIcon from '../../common/ButtonIcon';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { animateScroll } from 'react-scroll';
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
  Input
} from 'reactstrap';
import SummaryModal from '../Vendor/Modal';
import CredsModal from '../Vendor/CredsModal';
import BZAPIService from '../../../services/BZAPIService';
import ProductPriority from '../section/ProductPriority';
import ExecutionStatsTab from '../section/ExecutionStatsTab';

// constants
import SETTINGS from '../../../constants/settings';
import DefaultConfigTab from '../section/DefaultConfigTab';
import TabNav from '../section/TabNav';
import TabOne from '../section/TabOne';
import RiskScore from '../section/RiskScore';
import { sumBy } from 'lodash';
import { useScheduling } from '../../../hooks/useScheduling';

const ConfigFormMSFTWindowsServer = ({
  isReadOnly,
  vendor,
  // settings,
  vendorLabel,
  bugsDateBack,
  setBugsDateBack,
  vendorId,
  vendorPriorityOptions,
  vendorStatusOptions,
  // vendorResolutionOptions,
  snIntegrationCheck,
  services,
  vendors,
  priorityStats,
  setPriorityStats,
  // bugOptions,
  // selectedBugOption,
  // setSelectedBugOption,
  snCompanySysIdOptions,
  snCompanySysIdErrors,
  setVendorStatuses,
  vendorStatuses,
  fields,
  handleFieldChange,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  keywords,
  setKeywords,
  searchFields,
  setSearchFields,
  snCompanySysId,
  setSnCompanySysId,
  setServices,
  setVendors,
  buildVendorStat,
  setBugs,
  isConfigured,
  syncOnly,
  setSyncOnly,
  loading,
  bugRisk,
  setBugRisk,
  isServiceActive,
  setIsServiceActive,
  allRequired,
  setAllRequired,
  isUpdated,
  setIsUpdated
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  //  const [config, setConfig] = useState(null);
  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);
  const [isUpdatingCreds, setIsUpdatingCreds] = useState(false);

  const [isAddingMFA, setIsAddingMFA] = useState(false);

  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [validated, setValidated] = useState(null);
  const [isForceRun, setIsForceRun] = useState(false);

  const [riskError, setRiskError] = useState('');

  // Use scheduling hook for state and save function
  const {
    timeUnit,
    setTimeUnit,
    timeValue,
    setTimeValue,
    schedulingMode,
    setSchedulingMode,
    schedules,
    setSchedules,
    nextRun,
    setNextRun,
    saveBugServiceFrequency
  } = useScheduling();

  async function setBugServiceFrequency() {
    await saveBugServiceFrequency(vendorId);
  }

  function cancelCreds() {
    fields.username = '';
    fields.password = '';
    fields.mfaSecret = '';
    setIsAddingCredentials(false);
  }
  function toggleMFA() {
    fields.mfaSecret = '';
    setIsAddingMFA(!isAddingMFA);
  }
  async function saveServiceAWSSecret() {
    if (fields.mfaSecret.length > 0) {
      const data = {
        secret: {
          username: fields.username,
          password: fields.password,
          mfa_secret: fields.mfaSecret
        },
        vendorId: 'msft',
        key: 'admin'
      };
      return BZAPIService.createOrUpdateAWSSecret(data);
    } else {
      const data = {
        secret: {
          username: fields.username,
          password: fields.password
        },
        vendorId: 'msftserver',
        key: 'admin'
      };
      return BZAPIService.createOrUpdateAWSSecret(data);
    }
  }
  async function testCreds() {
    setIsTestingValidCredentials(true);
    if (fields.mfaSecret.length > 0) {
      const data = {
        username: fields.username,
        password: fields.password,
        mfa_secret: fields.mfaSecret
      };
      try {
        const result = await BZAPIService.vendorTestCreds(vendorId, data);
        setIsTestingValidCredentials(false);
        if (result && result.completed) {
          // valid creds
          setIsValidCredentials(true);
          setIsAddingCredentials(false);
          setIsUpdatingCreds(true);
          toast.success(`Credentials validated!`);
        } else {
          toast.error('Error validating credentials.');
          setIsAddingCredentials(false);
          setIsValidCredentials(false);
          setIsTestingValidCredentials(false);
        }
      } catch (e) {
        toast.error('Credentials failed validation.');
        setIsTestingValidCredentials(false);
        setIsValidCredentials(false);
      }
    } else {
      const data = {
        username: fields.username,
        password: fields.password
      };
      try {
        const result = await BZAPIService.vendorTestCreds(vendorId, data);
        setIsTestingValidCredentials(false);
        if (result && result.completed) {
          // valid creds
          setIsValidCredentials(true);
          setIsAddingCredentials(false);
          toast.success(`Credentials validated!`);
        } else {
          toast.error('Error validating credentials.');
          setIsAddingCredentials(false);
          setIsValidCredentials(false);
          setIsTestingValidCredentials(false);
        }
      } catch (e) {
        toast.error('Credentials failed validation.');
        setIsTestingValidCredentials(false);
        setIsValidCredentials(false);
      }
    }
  }

  async function saveConfig(awsSecret) {
    // save client config
    const vendorPriorities = priorityMaps.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });

    const data = {
      secretId: awsSecret.Name,
      bugsDateBack: bugsDateBack,
      snCompanySysId: snCompanySysId.value ? snCompanySysId.value : fields.snCompanySysId,
      snAffectedCIQuery: fields.snAffectedCIQuery,
      vendorPriorities,
      vendorStatuses,
      type: SETTINGS.VENDOR,
      excludedKws: keywords,
      searchFields: searchFields,
      bugRiskScore: bugRisk
    };

    return BZAPIService.saveSetting(vendorId, syncOnly, data, isForceRun, isUpdatingCreds);
  }

  async function handleSave() {
    setRiskError('');
    try {
      setIsSubmitted(true);
      setIsLoading(true);
      // Validate
      if (!bugsDateBack.length || !snCompanySysId?.value?.length) {
        setValidated(false);
        setActiveTab('3');
        setIsLoading(false);
        return;
      }
      if (!priorityMaps.length || !vendorStatuses.length) {
        setValidated(false);
        setActiveTab('4');
        setIsLoading(false);
        return;
      }

      // Validate Risk Score
      const activeRisk = bugRisk.filter(y => {
        return y.active;
      });
      const activeSum = sumBy(activeRisk, risk => {
        return risk.value;
      });

      if (activeSum < 100 && activeSum > 1) {
        console.log('Bug risk share is less than 100');
        setValidated(false);
        setActiveTab('5');
        setIsLoading(false);
        setRiskError('Bug risk share total must be 100');
        return;
      }

      let awsSecret;

      if (fields.password && fields.username && isValidCredentials) {
        // Updated secrets
        awsSecret = await saveServiceAWSSecret();
      } else {
        // use existing secrets
        awsSecret = { Name: fields.secretId };
      }
      // console.log('awsSecret', awsSecret);
      if (!awsSecret || !awsSecret.Name) {
        setValidated(false);
        setActiveTab('2');
        setIsLoading(false);
        toast.error(`Credentials test missing.`);
        return;
      }

      await saveConfig(awsSecret);
      // set updated secretId
      setBugServiceFrequency();
      fields.secretId = awsSecret.Name;
      setIsLoading(false);
      setIsSubmitted(false);
      setModalOpen(false);
      setIsForceRun(false);
      setIsUpdatingCreds(false);
      setActiveTab('1');
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
  }

  function handleValidationError() {
    setModalOpen(!modalOpen);
    animateScroll.scrollTo(70);
  }

  useEffect(() => {
    setIsUpdated(true);
    if (
      bugsDateBack?.length &&
      snCompanySysId?.value &&
      priorityMaps?.length &&
      !priorityMaps.some(mapping => !mapping.snPriority || !mapping.vendorPriority) &&
      vendorStatuses.length &&
      (fields.secretId || (fields.password && fields.username))
    ) {
      setAllRequired(true);
    } else {
      setAllRequired(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fields,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    bugsDateBack,
    priorityStats,
    vendorStatuses,
    priorityMaps,
    keywords,
    searchFields,
    snCompanySysId,
    bugRisk
  ]);

  return (
    <>
      <TabNav
        vendorId={vendorId}
        credentials={true}
        activeTab={activeTab}
        snIntegrationCheck={snIntegrationCheck}
        setActiveTab={setActiveTab}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setServices={setServices}
        setVendors={setVendors}
        buildVendorStat={buildVendorStat}
        setPriorityStats={setPriorityStats}
        setBugs={setBugs}
        isConfigured={isConfigured}
        hasBugRisk={true}
        loading={loading}
      />

      <TabContent>
        <TabOne
          vendorId={vendorId}
          vendorLabel={vendorLabel}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          snIntegrationCheck={snIntegrationCheck}
          services={services}
          vendors={vendors}
          priorityStats={priorityStats}
          isConfigured={isConfigured}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setIsForceRun={setIsForceRun}
          timeUnit={timeUnit}
          setTimeUnit={setTimeUnit}
          timeValue={timeValue}
          setTimeValue={setTimeValue}
          schedulingMode={schedulingMode}
          setSchedulingMode={setSchedulingMode}
          schedules={schedules}
          setSchedules={setSchedules}
          nextRun={nextRun}
          setNextRun={setNextRun}
          loading={loading}
          isServiceActive={isServiceActive}
          setIsServiceActive={setIsServiceActive}
        />
        <form noValidate style={{ minWidth: '100%' }}>
          <input type="hidden" value="prayer" />
          <TabPane tabId="2">
            {activeTab === '2' && (
              <Card bg={'light'} text={'dak'} className="mb-4">
                {/* <FalconCardHeader title="Vendor settings" /> */}
                <CardBody>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          Microsoft Admin Credentials
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        {!isAddingCredentials ? (
                          <>
                            <div>
                              <ButtonIcon
                                onClick={() => setIsAddingCredentials(true)}
                                color="falcon-default"
                                size="sm"
                                icon="plus"
                                iconClassName="fs--2"
                              >
                                Set Credentials
                              </ButtonIcon>
                              {/* <Button variant="outline-primary" onClick={() => setIsAddingCredentials(true)}>
                          <FontAwesomeIcon icon={'plus'} /> Set Credentials
                        </Button> */}

                              {fields.secretId || isValidCredentials ? (
                                <>
                                  {'  '}
                                  <FontAwesomeIcon icon={'check'} style={{ color: 'green', marginLeft: '10px' }} />{' '}
                                  Microsoft Credentials Stored
                                </>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  id="username"
                                  onChange={handleFieldChange}
                                  value={fields.username}
                                  label={'Microsoft Admin Username'}
                                  showFeedback={!isValidCredentials}
                                  feedback={'Username has not been validated or is invalid.'}
                                  placeholder="Enter Microsoft Admin Username"
                                  style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col lg="6">
                                <FieldGroup
                                  type="password"
                                  id="password"
                                  autoComplete="new-password"
                                  onChange={handleFieldChange}
                                  value={fields.password}
                                  label={'Microsoft Admin Password'}
                                  showFeedback={!isValidCredentials}
                                  feedback={'Password has not been validated or is invalid.'}
                                  placeholder="Enter Microsoft Admin Password"
                                  style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                            </Row>
                            <Row form>
                              <Col lg="12">
                                <FormGroup>
                                  <Col>
                                    <div className="ml-1">
                                      <Input onChange={toggleMFA} type="checkbox" checked={isAddingMFA} />
                                      <Label check>Set Multi-factor Authentication Credentials</Label>
                                    </div>
                                  </Col>

                                  {!isAddingMFA ? (
                                    <Col>
                                      <div>
                                        {fields.mfaSecret || isValidCredentials ? (
                                          <>
                                            {'  '}
                                            <FontAwesomeIcon
                                              icon={'check'}
                                              style={{ color: 'green', marginLeft: '10px' }}
                                            />{' '}
                                            Microsoft MFA Stored
                                          </>
                                        ) : null}
                                      </div>
                                    </Col>
                                  ) : (
                                    <>
                                      <Row>
                                        <Col lg="6">
                                          <FieldGroup
                                            type="text"
                                            id="mfaSecret"
                                            onChange={handleFieldChange}
                                            value={fields.mfaSecret}
                                            label={'Microsoft MFA Secret'}
                                            showFeedback={!isValidCredentials}
                                            feedback={'MFA Secret has not been validated or is invalid.'}
                                            placeholder="Enter MFA Secret"
                                            style={{ marginBottom: '10px' }}
                                          />
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                  <FormFeedback
                                    className={!fields.secretId && !fields.refreshToken && isSubmitted ? 'd-block' : ''}
                                    type="invalid"
                                  >
                                    Please specify credentials.
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </Row>
                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={vendorId}
                            />
                            <ButtonIcon
                              onClick={cancelCreds}
                              color="falcon-default"
                              size="sm"
                              icon="times"
                              iconclassname="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Cancel
                            </ButtonIcon>
                          </>
                        )}
                        <FormFeedback
                          className={!fields.secretId && !fields.refreshToken && isSubmitted ? 'd-block' : ''}
                          type="invalid"
                        >
                          Please specify credentials.
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </TabPane>

          <DefaultConfigTab
            vendor={vendor}
            activeTab={activeTab}
            vendorId={vendorId}
            vendorLabel={vendorLabel}
            bugsDateBack={bugsDateBack}
            setBugsDateBack={setBugsDateBack}
            isSubmitted={isSubmitted}
            snCompanySysIdErrors={snCompanySysIdErrors}
            snCompanySysIdOptions={snCompanySysIdOptions}
            setSnCompanySysId={setSnCompanySysId}
            snCompanySysId={snCompanySysId}
            fields={fields}
            handleFieldChange={handleFieldChange}
          />

          <TabPane tabId="4">
            {activeTab === '4' && (
              <ProductPriority
                title="Default Bug Configuration"
                vendorPriorityOptions={vendorPriorityOptions}
                vendorStatusOptions={vendorStatusOptions}
                setVendorStatuses={setVendorStatuses}
                vendorStatuses={vendorStatuses}
                isSubmitted={isSubmitted}
                priorityMaps={priorityMaps}
                setPriorityMaps={setPriorityMaps}
                snPriorityOptions={snPriorityOptions}
                keywords={keywords}
                setKeywords={setKeywords}
                searchFields={searchFields}
                setSearchFields={setSearchFields}
              />
            )}
          </TabPane>
          <div style={{ minWidth: '100%' }}>
            <TabPane tabId="5">
              {activeTab === '5' && <RiskScore bugRisk={bugRisk} setBugRisk={setBugRisk} riskError={riskError} />}
            </TabPane>
          </div>
          <TabPane tabId="6">{activeTab === '6' && <ExecutionStatsTab vendorId={vendorId} />}</TabPane>

          <Row className={`${activeTab === '1' ? 'd-none' : ''} flex-between-center`}>
            <Col xs="auto">
              <Button
                block
                color="falcon-danger"
                onClick={() => {
                  console.log(`/vendors/${vendorId}/configuration`);
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <SummaryModal
                modalOpen={modalOpen}
                isReadOnly={isReadOnly}
                setModalOpen={setModalOpen}
                handleSave={handleSave}
                isLoading={isLoading}
                vendorLabel={vendorLabel?.replace('Systems', 'Networks')}
                vendorId={vendorId}
                validated={validated}
                setValidated={setValidated}
                isAddingCredentials={isAddingCredentials}
                syncOnly={syncOnly}
                setSyncOnly={setSyncOnly}
                handleValidationError={handleValidationError}
                allRequired={allRequired}
                isUpdated={isUpdated}
              />
            </Col>
          </Row>
        </form>
      </TabContent>
    </>
  );
};
ConfigFormMSFTWindowsServer.propTypes = {
  vendor: PropTypes.object,
  isReadOnly: PropTypes.bool,
  settings: PropTypes.object,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorResolutionOptions: PropTypes.array,
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysId: PropTypes.object,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  vendors: PropTypes.array,
  bugs: PropTypes.object,
  priorityStats: PropTypes.object,
  setPriorityStats: PropTypes.func,
  bugOptions: PropTypes.array,
  selectedBugOption: PropTypes.object,
  setSelectedBugOption: PropTypes.func,
  snCompanySysIdErrors: PropTypes.bool,
  vendorEventScopes: PropTypes.array,
  setVendorEventScopes: PropTypes.func,
  vendorResolutions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  vendorStatuses: PropTypes.array,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  priorityMaps: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  snPriorityOptions: PropTypes.array,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  setSnCompanySysId: PropTypes.func,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  setServices: PropTypes.func,
  setVendors: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setBugs: PropTypes.func,
  isConfigured: PropTypes.bool,
  syncOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func,
  loading: PropTypes.bool,
  bugRisk: PropTypes.array,
  setBugRisk: PropTypes.func,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number,
  allRequired: PropTypes.bool,
  isUpdated: PropTypes.bool,
  setAllRequired: PropTypes.func,
  setIsUpdated: PropTypes.func
};
export default ConfigFormMSFTWindowsServer;
